var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsEnum, IsNumber, IsObject, IsOptional, IsString, IsUUID, } from 'class-validator';
import { Role } from '../../roles/index.js';
import { UserProfileDto } from './user.profile.dto.js';
export class FileUploadFullSizeDto {
    id;
    // The document list renders the upload date, and the delete affordance is
    // gated on who uploaded the file (a patient may only remove their own), so
    // these three have to reach the client — including the patient's.
    createdAt;
    createdBy;
    createdByRole;
    updatedAt;
    originalFilename;
    filename;
    patientId;
    /**
     * The day of the appointment whose documentation the file is attached to (any
     * version), null for a file uploaded on its own. Such a file belongs to the
     * documentation's history and cannot be removed from the document list.
     */
    documentationDate;
    officeId;
    patient;
    office;
    blob;
    file;
    status;
    get patientOffice() {
        return this.patient?.officeId;
    }
    progressPercent;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], FileUploadFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], FileUploadFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], FileUploadFullSizeDto.prototype, "createdBy", void 0);
__decorate([
    IsEnum(Role),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], FileUploadFullSizeDto.prototype, "createdByRole", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], FileUploadFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], FileUploadFullSizeDto.prototype, "originalFilename", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], FileUploadFullSizeDto.prototype, "filename", void 0);
__decorate([
    IsUUID(),
    Expose({ groups: [Role.THERAPIST, Role.MANAGEMENT, Role.ADMIN] }),
    __metadata("design:type", String)
], FileUploadFullSizeDto.prototype, "patientId", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    Expose({ groups: [Role.THERAPIST, Role.MANAGEMENT, Role.ADMIN] }),
    __metadata("design:type", Object)
], FileUploadFullSizeDto.prototype, "documentationDate", void 0);
__decorate([
    IsUUID(),
    Expose({ groups: [Role.THERAPIST, Role.MANAGEMENT, Role.ADMIN] }),
    __metadata("design:type", String)
], FileUploadFullSizeDto.prototype, "officeId", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Expose({ groups: [Role.THERAPIST, Role.MANAGEMENT, Role.ADMIN] }),
    __metadata("design:type", Function)
], FileUploadFullSizeDto.prototype, "patient", void 0);
__decorate([
    IsObject(),
    Expose({ groups: [Role.THERAPIST, Role.MANAGEMENT, Role.ADMIN] }),
    __metadata("design:type", Function)
], FileUploadFullSizeDto.prototype, "office", void 0);
__decorate([
    Exclude(),
    __metadata("design:type", Object)
], FileUploadFullSizeDto.prototype, "blob", void 0);
__decorate([
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], FileUploadFullSizeDto.prototype, "file", void 0);
__decorate([
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], FileUploadFullSizeDto.prototype, "status", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], FileUploadFullSizeDto.prototype, "patientOffice", null);
__decorate([
    IsNumber(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Number)
], FileUploadFullSizeDto.prototype, "progressPercent", void 0);
//# sourceMappingURL=file-upload.full-size.dto.js.map